import i18n from "@/i18n";

const WIDGET_IDS = {
  admin: 72000004815,
  default: 72000003292,
};

let loadedWidgetId = null;
let loadedLocale = null;

function initStub() {
  var n = function () {
    n.q.push(arguments);
  };
  n.q = [];
  window.FreshworksWidget = n;
}

function getLocale() {
  // i18n.locale is the authoritative source: it prioritizes user.language
  // (set in Login.vue) and falls back to detectLanguage()
  // (URL → localStorage → browser → "es") otherwise.
  // Freshworks requires "pt-BR" with uppercase BR; "es" and "en" match as-is.
  const LOCALE_MAP = { es: "es", en: "en", "pt-br": "pt-BR" };
  const current = (i18n.locale || "").toLowerCase();
  return LOCALE_MAP[current] || "es";
}

function destroyWidget() {
  if (typeof window.FreshworksWidget === "function") {
    window.FreshworksWidget("destroy");
  }
  const oldScript = document.getElementById("fw-widget-script");
  if (oldScript) oldScript.remove();
  // "destroy" empties the widget but leaves its loader iframe and container behind: without
  // this, every language or role switch stacked another pair in the page.
  document
    .querySelectorAll("#freshworks-frame, #freshworks-container")
    .forEach((node) => node.remove());
  delete window.fwSettings;
  loadedWidgetId = null;
  loadedLocale = null;
}

export function loadFreshworksWidget(userGroup, userRoles) {
  if (userGroup === "sysadmin") {
    if (loadedWidgetId) destroyWidget();
    return;
  }

  const isAdmin =
    userGroup === "customer" && userRoles?.includes("admin");
  const isConsultant =
    userGroup === "collaborator" && userRoles?.includes("consultant");
  const widgetId =
    isAdmin || isConsultant ? WIDGET_IDS.admin : WIDGET_IDS.default;

  const locale = getLocale();

  if (loadedWidgetId === widgetId && loadedLocale === locale) {
    window.FreshworksWidget?.("show", "launcher");
    return;
  }

  if (loadedWidgetId) destroyWidget();

  initStub();

  window.fwSettings = { widget_id: widgetId, locale };
  window.FreshworksWidget("setLabels", {
    es: {
      banner: "Bienvenida al servicio de soporte Yourney",
      launcher: "Soporte",
      contact_form: { title: "Contáctanos" },
    },
    en: {
      banner: "Welcome to Yourney support",
      launcher: "Support",
      contact_form: { title: "Contact Us" },
    },
    "pt-BR": {
      banner: "Boas-vindas ao suporte Yourney",
      launcher: "Suporte",
      contact_form: { title: "Fale conosco" },
    },
  });
  const script = document.createElement("script");
  script.id = "fw-widget-script";
  script.src = `https://widget.freshworks.com/widgets/${widgetId}.js`;
  script.async = true;
  script.defer = true;
  document.body.appendChild(script);
  loadedWidgetId = widgetId;
  loadedLocale = locale;
}
